import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import * as global from "../global";
import { API_URL } from "src/environments/api-url";
import { lastValueFrom } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class PatientScriptSureService {
    constructor(private httpClient: HttpClient) {}

    async vendorLogin(payload: any): Promise<any> {
        try {
            const response: any = await lastValueFrom(
                this.httpClient.post(
                    global.url + API_URL.SCRIPTSURE.vendorLogin,
                    payload,
                    { withCredentials: true }
                )
            );
            return response;
        } catch (error) {
            // Handle the error properly, you can add specific error logging here if needed
            console.error("Error during vendor login:", error.message || error);
            throw error;
        }
    }

    async vendorLogout(payload: any): Promise<any> {
        try {
             const response: any = await lastValueFrom(
                 this.httpClient.post(
                     global.url + API_URL.SCRIPTSURE.vendorLogout,
                     payload,
                     { withCredentials: true }
                 )
            );

            if (response.status !== 200) {
                throw new Error(response.message);
            }

            return response;
        } catch (error) {
            // Handle the error properly, you can add specific error logging here if needed
            console.error(
                "Error during vendor logout:",
                error.message || error
            );
            throw error;
        }
    }
}
